import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {JwtHelperService} from '@auth0/angular-jwt';
import {User} from '../model/user';
import {AuthenResponse} from '../model/authen-response';
import * as _ from 'lodash';
import {Observable} from 'rxjs';
import {Login} from '../model/login';
import {API} from 'src/shared/apis/api';
import {CommonConstants} from "../../shared/constants/common-constants.enum";
import {RoleTypeEnum} from "../../shared/constants/role-type.enum";
import {NotificationService} from "../../shared/service/notification.service";
import {NotificationType} from "../../shared/constants/notification-type.enum";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly helper = new JwtHelperService();
  currentUserLogin: User;

  private readonly STORE_KEY = 'lastAction';
  private readonly TOKEN_KEY = 'token';

  constructor(
    protected httpClient: HttpClient,
    private router: Router,
    private notificationService: NotificationService
  ) {
    this.getUserFromToken();
  }

  setupToken(response: AuthenResponse) {
    localStorage.setItem(this.TOKEN_KEY, response.token);
    localStorage.setItem(this.STORE_KEY, _.toString(Date.now()));
    this.getUserFromToken();
  }

  getUserFromToken(): void {
    if (!this.isValidToken() || !this.currentUserLogin) {
      this.logout();
    }
  }

  isValidToken() {
    const token = this.getAccessToken();
    if (token && !this.helper.isTokenExpired(token)) {
      try {
        const payload = this.helper.decodeToken(token);
        this.currentUserLogin = JSON.parse(payload.sub);
        localStorage.setItem(CommonConstants.IS_ADMIN, String(this.currentUserLogin.admin));
        localStorage.setItem(CommonConstants.ROLE_TYPE, String(this.currentUserLogin.roleType));
        localStorage.setItem(CommonConstants.USER_COOPERATIVE_NO, String(this.currentUserLogin.cooperativeNo));
        localStorage.setItem(CommonConstants.CUSTOMER_NO, String(this.currentUserLogin.customerNo));
        localStorage.setItem(CommonConstants.STATION_NO, String(this.currentUserLogin.stationNo));
      } catch (error) {
        // ignore handling
      }
      return true;
    }
    return false;
  }

  login(credential: Login): Observable<boolean> {
    localStorage.clear();
    return this.httpClient
      .post(API.LOGIN, credential)
      .map((res: AuthenResponse) => {
        if (res && res.token) {
          this.setupToken(res);
          return true;
        }
      })
      .catch(e => {
        return Observable.of(false);
      });
  }

  logout() {
    localStorage.clear();
    this.currentUserLogin = null;
    this.router.navigate(['login']).finally();
  }

  getAccessToken(): string {
    return localStorage.getItem(this.TOKEN_KEY);
  }

  gotoPage(errorCode?: number, redirectUrl?: string) {
    // for home page
    if (errorCode === 403) {
      this.router.navigate(['access-denied']).finally();
    } else {
      this.router.navigate(['meter-cooperative/home']).finally();
    }

  }
}
